import { useQuery } from "@tanstack/react-query";
import { Badge } from "primereact/badge";
import { OverlayPanel } from "primereact/overlaypanel";
import { classNames as cx } from "primereact/utils";
import { useEffect, useRef } from "react";
import { requests } from "../../../../../services/http-common";
import { If } from "../../../../If/If";
import { NotificationItem } from "./NotificationItem/NotificationItem";
import classes from "./Notifications.module.scss";

export const Notifications = () => {
  const op = useRef(null);

  const { data: notificationsData, refetch: refetchNotifications } = useQuery({
    queryKey: [`notifications-list`],
    queryFn: () => {
      return requests.get(`/notification`);
    },
    retry: false,
    enabled: false,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      refetchNotifications();
    }, 20000);
    return () => clearInterval(interval);
  }, [refetchNotifications]);

  const handleNotificationsClick = (
    e: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    if (!notificationsData?.total) {
      return;
    }
    //@ts-ignore
    op.current && op.current.toggle(e);
  };

  return (
    <div className={classes.notifications}>
      <i
        className={cx("pi pi-bell p-overlay-badge", classes.icon, {
          [classes.active]: notificationsData?.total,
        })}
        onClick={handleNotificationsClick}
      >
        <If
          condition={notificationsData?.result.some(
            (notification: any) => !notification.hasSeen
          )}
        >
          <Badge
            style={{ width: "12px", height: "12px", top: 8, right: 8 }}
            severity="danger"
          />
        </If>
      </i>
      <OverlayPanel
        ref={op}
        id="overlay_panel"
        style={{ width: "512px" }}
        className={classes.overlayPanel}
      >
        <div className={classes.title}>Notifications</div>
        <div className={classes.listContainer}>
          <If condition={notificationsData?.result.length}>
            {notificationsData?.result.map((notification: any) => {
              return (
                <NotificationItem
                  key={notification?.id}
                  refetchNotifications={refetchNotifications}
                  {...notification}
                />
              );
            })}
            <div className={classes.empty}></div>
          </If>
        </div>
      </OverlayPanel>
    </div>
  );
};
